import { defineStore } from 'pinia';
import { getSystemConfig, getSystemProductList } from '@service/system';
import { isMobile, downloadVideo } from '@utils/util';
import { getDownloadVideo } from '@service/video';

const name = 'system';
const useSystemStore = defineStore(name, {
  state: () => ({
    isMobileWeb: isMobile,
    isMobileMenu: false,
    isEmailVerified: false,
    isDownloading: false,
    website_status: -1,
    motion_default: [] as SystemItem['motion_default'],
    aspect_ratio: [] as SystemItem['aspect_ratio'],
    video_product: {} as SystemItem['video_product'],
    credit_product_list_new: {} as SystemItem['credit_product_list_new'],
    emotion_list: [] as SystemItem['emotion_list'],
    product_compare_tb_row_name:
      [] as SystemItem['product_compare_tb_row_name'],
    country_code: '' as string,
    default_currency: '' as string,
    feedback_list: [] as SystemItem['feedback_list'],
    out_site_url_video_limit: 0 as SystemItem['out_site_url_video_limit'],
  }),

  actions: {
    async setSystemConfig() {
      await this.getProductList();
      await this.getConfig();
    },
    async getConfig() {
      const res = await getSystemConfig();

      if (res) {
        Object.assign(this.$state, res);
      }
    },

    async getProductList() {
      const res = await getSystemProductList({
        currency: localStorage.getItem('isUSD') === 'true' ? 'USD' : '',
      });

      if (res?.credit_product_list_new) {
        Object.assign(this.$state, res);
      }
    },
    async downloadVideo(item_id: string) {
      this.isDownloading = true;
      const res = await getDownloadVideo({ item_id });
      if (res?.url?.url) {
        await downloadVideo(res.url.url);
      }
      this.isDownloading = false;
    },
  },
});

export default useSystemStore;
